import React from 'react';

function WindowArrow(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M3.875 3H20.125C21.1602 3 22 3.83982 22 4.875V19.125C22 20.1602 21.1602 21 20.125 21H3.875C2.83982 21 2 20.1602 2 19.125V4.875C2 3.83982 2.83982 3 3.875 3ZM3.25 8.25V19.125C3.25 19.4698 3.53018 19.75 3.875 19.75H20.125C20.4698 19.75 20.75 19.4698 20.75 19.125V8.25H3.25ZM20.75 7H3.25V4.875C3.25 4.53018 3.53018 4.25 3.875 4.25H20.125C20.4698 4.25 20.75 4.53018 20.75 4.875V7Z"
        fillRule="evenodd"
      />
      <path d="M12.4804 10.6107C12.2368 10.442 11.9 10.4661 11.6831 10.6831L11.6107 10.7696C11.442 11.0132 11.4661 11.35 11.6831 11.5669L13.0334 12.9167H9.125L9.03264 12.9234C8.73126 12.9681 8.5 13.2279 8.5 13.5417C8.5 13.8868 8.77982 14.1667 9.125 14.1667H13.2001L11.6831 15.6831L11.6107 15.7696C11.442 16.0132 11.4661 16.35 11.6831 16.5669C11.9271 16.811 12.3229 16.811 12.5669 16.5669L15.0669 14.0669L15.1393 13.9804C15.308 13.7368 15.2839 13.4 15.0669 13.1831L12.5669 10.6831L12.4804 10.6107Z" />
    </svg>
  );
}

export default WindowArrow;
